export const NETWORK_QUERY_PARAM = 'network';
export const TX_HASH_LOCAL_STORAGE = 'TX_HASH'
export const UNREGISTER_CHAIN_PARAM = 'unregister_chain'
export const REGISTER_CHAIN_PARAM = 'register_chain'